// extracted by mini-css-extract-plugin
export default {"error-container":"ErrorBoundary_error-container__Iaako","error-title":"ErrorBoundary_error-title__kb5xL"};